const SocialLinks = () => {
    return (
      <div style={styles.socialContainer}>
        <a href="https://www.facebook.com/ShehabCorp/" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-facebook-f" style={styles.icon}></i>
        </a>
         <a href="https://www.instagram.com/shehab_engineering/?g=5" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-instagram" style={styles.icon}></i>
        </a>
        <a href="https://www.linkedin.com/company/shehab-engineering/" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-linkedin-in" style={styles.icon}></i>
        </a>
        {/* <a href="https://www.twitter.com/" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-twitter" style={styles.icon}></i>
        </a> */}
       
      </div>
    );
  };
  
  const styles = {
    socialContainer: {
      display: "flex",
      justifyContent: "center",
      gap: "15px",
      padding: "10px",
    },
    icon: {
      fontSize: "24px",
      color: "black",
      textDecoration: "none",
    }
  };
  
  export default SocialLinks;
  